var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@0.5xverify red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walk-in/out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Walkin-out-Live-view-Copy-10",
    transform: "translate(-872.000000, -245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(79.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ex-employee-Copy",
    transform: "translate(584.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify-red",
    transform: "translate(209.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "orange-Rectangle",
    fill: "#F6A14C",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 2.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.800000, 7.200000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/checklist"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.800000, 0.800000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7.2,
    y: 1.6,
    width: 12,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    points: "0 1.69267698 1.83813815 3.53081513 5.36895327 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.800000, 7.200000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    x: 7.2,
    y: 1.6,
    width: 12,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    points: "0 1.69267698 1.83813815 3.53081513 5.36895327 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.800000, 13.600000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#FFFFFF",
    x: 7.2,
    y: 1.6,
    width: 12,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    points: "0 1.69267698 1.83813815 3.53081513 5.36895327 0"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationOrange);
export default __webpack_public_path__ + "static/media/verification_orange.baac99e59e87932867a5407c5496cb6b.svg";
export { ForwardRef as ReactComponent };